import React, { Component } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";

import Button from "../../../button/button";
import { be, bm } from "../../../../utils/bliss";
import "./newsletterThanks.css";
import Headline from "../../../headline/headline";
import Text from "../../../text/text";
import mask from "./img/mask.png";

const MODULE_NAME = "NewsletterThanks";

class NewsletterThanks extends Component {
  render() {
    return (
      <div className={bm(MODULE_NAME)}>
        <div className={be(MODULE_NAME, "left")}>
          <Headline bold component="h2" subheadline>
            Děkujeme za účast!
          </Headline>
          <div className={be(MODULE_NAME, "spacing", "xs")} />
          <Text small>Slibujeme, že nebudeme moc otravovat</Text>
          <div className={be(MODULE_NAME, "spacing", "sm")} />
          <Button mini onClick={this.props.onClose} type="submit">
            HOTOVO
          </Button>
        </div>
        <div className={be(MODULE_NAME, "right")}>
          <div className={be(MODULE_NAME, "imageBox")}>
            <img alt="maska" className={be(MODULE_NAME, "image")} src={mask} />
          </div>
        </div>
      </div>
    );
  }
}

NewsletterThanks.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default NewsletterThanks;
